import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// COMPONENTS
import Layout from '../../components/layouts/Layout';
import Loader from '../../components/common/Loader';
import CustomerEdit from '../../components/admin/customers/CustomerEdit';

//NETWORK
import useAdminRequest from '../../requests/AdminRequest';
import Config from '../../Config';

import { AdminRoutes } from '../../routes/AdminRoutes';

import CustomersFormattedMessages from '../../messages/admin/CustomersFormattedMessages';

const CustomerView = (props) => {
  const { accessLevel, accessType } = props;

  if (
    accessLevel !== Config.accessLevel.admin ||
    accessType !== Config.accessType.roxAdmin
  ) {
    return null;
  }

  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [comments, setComments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [cardDetails, setCardDetails] = useState(null);
  const [headerButtons, setHeaderButtons] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageTitle, setPageTitle] = useState(
    CustomersFormattedMessages.accountInformation
  );
  const [showPageTitleButtons, setShowPageTitleButtons] = useState(null);
  const [backButtonHandler, setBackButtonHandler] = useState(null);
  const [managePoolNumbers, setManagePoolNumbers] = useState(false);
  const [manageDedicatedNumbers, setManageDedicatedNumbers] = useState(false);

  const {
    getSingleCustomer,
    getCardDetails,
    getCustomerAttachments,
    getCustomerComments,
  } = useAdminRequest();

  const load = async () => {
    const [customer, comments, attachments, cardDetails] = await Promise.all([
      getSingleCustomer(id, props.errorHandler),
      getCustomerComments(id, props.errorHandler),
      getCustomerAttachments(id, props.errorHandler),
      getCardDetails(id, props.errorHandler),
    ]);

    setCustomer(customer);
    setComments(comments);
    setAttachments(attachments);
    setCardDetails(cardDetails);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, [id]);

  const handleBackButtonClick = (to) => {
    if (to && to.toLowerCase() === 'refresh') {
      setLoading(true);
      load();
      return;
    }

    if (managePoolNumbers || manageDedicatedNumbers) {
      setManagePoolNumbers(false);
      setManageDedicatedNumbers(false);
    } else {
      props.navigate(-1);
    }
  };

  const refreshCustomer = () => {
    setLoading(true);
    load();
  };

  return (
    <Layout
      title={
        managePoolNumbers
          ? CustomersFormattedMessages.managePoolNumbers
          : manageDedicatedNumbers
          ? CustomersFormattedMessages.manageDedicatedNumbers
          : CustomersFormattedMessages.accountInformation
      }
      routes={AdminRoutes}
      accessLevel={accessLevel}
      accessType={accessType}
      backButtonText={CustomersFormattedMessages.backText}
      handleBackButton={() => handleBackButtonClick('list')}
      titleRowRightComponent={
        !managePoolNumbers && !manageDedicatedNumbers && headerButtons
      }
    >
      {loading ? (
        <Loader />
      ) : (
        <CustomerEdit
          customer={customer}
          comments={comments}
          setComments={setComments}
          attachments={attachments}
          setAttachments={setAttachments}
          cardDetails={cardDetails}
          backButtonClick={handleBackButtonClick}
          refreshCustomer={refreshCustomer}
          errorHandler={props.errorHandler}
          updateActingCustomerDetails={props.updateActingCustomerDetails}
          navigate={props.navigate}
          isTransferDedicatedNumber={
            props.location?.state?.isTransferDedicatedNumber
          }
          setHeaderButtons={setHeaderButtons}
          managePoolNumbers={managePoolNumbers}
          setManagePoolNumbers={setManagePoolNumbers}
          manageDedicatedNumbers={manageDedicatedNumbers}
          setManageDedicatedNumbers={setManageDedicatedNumbers}
        />
      )}
    </Layout>
  );
};

export default CustomerView;
